import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { isInValidValue } from '../../../../helpers/value'
import {
  getBussinessSize,
  getTopByIndustry,
  getTopByProvince,
  getYearOfOperation,
} from './thunk'

const initialState = {
  topIndustryIds: [],
  topIndustries: {},

  topProvinceIds: [],
  topProvinces: {},

  businessSizeIds: [],
  businessSize: {},

  yearsOfOperationIds: [],
  yearsOfOperation: {},

  loading: {
    topIndustries: true,
    topProvinces: true,
    businessSize: true,
    yearsOfOperation: true,
  },
}

const slice = createSlice({
  name: 'portfolio/summary/segmentation',
  initialState,
  reducers: {
    resetStore: () => initialState,
  },
  extraReducers: (builder) => {
    //getTopByIndustry
    builder.addCase(getTopByIndustry.pending, (state) => {
      state.loading.topIndustries = true
    })
    builder.addCase(getTopByIndustry.fulfilled, (state, { payload = [] }) => {
      const data = payload.map((item) => ({
        ...item,
        id: item.vsicId,
        name: item.vsicId,
        numberCompanies: item.numberBusiness,
        percentCompanies: item.totalPercentCompanies,
      }))
      state.topIndustryIds = data.map((item) => item.id)
      state.topIndustries = keyBy(data, 'id')
      state.loading.topIndustries = false
    })
    builder.addCase(getTopByIndustry.rejected, (state, action) => {
      state.loading.topIndustries = action.payload.loading
    })
    //getTopByProvince
    builder.addCase(getTopByProvince.pending, (state) => {
      state.loading.topProvinces = true
    })
    builder.addCase(getTopByProvince.fulfilled, (state, { payload = [] }) => {
      const data = payload.map((item) => ({
        ...item,
        id: item.provinceId,
        name: item.provinceName,
        numberCompanies: item.numberBusiness,
        percentCompanies: item.totalPercentCompanies,
      }))
      state.topProvinceIds = data.map((item) => item.id)
      state.topProvinces = keyBy(data, 'id')
      state.loading.topProvinces = false
    })
    builder.addCase(getTopByProvince.rejected, (state, action) => {
      state.loading.topProvinces = action.payload.loading
    })
    //getBussinessSize
    builder.addCase(getBussinessSize.pending, (state) => {
      state.loading.businessSize = true
    })
    builder.addCase(getBussinessSize.fulfilled, (state, { payload = [] }) => {
      const data = payload.map((item) => ({
        ...item,
        id: item.analysisIndicatorTypeId,
        name: item.analysisIndicatorTypeName,
        numberCompanies: item.numberCompanies,
        percentCompanies: item.percentCompanies,
      }))
      state.businessSizeIds = data.map((item) => item.id)
      state.businessSize = keyBy(data, 'id')
      state.loading.businessSize = false
    })
    builder.addCase(getBussinessSize.rejected, (state, action) => {
      state.loading.businessSize = action.payload.loading
    })
    //getYearOfOperation
    builder.addCase(getYearOfOperation.pending, (state) => {
      state.loading.yearsOfOperation = true
    })
    builder.addCase(getYearOfOperation.fulfilled, (state, { payload = [] }) => {
      const data = payload.map((item) => ({
        ...item,
        id: item.analysisIndicatorTypeId,
        name: item.analysisIndicatorTypeName,
        numberCompanies: item.numberCompanies,
        percentCompanies: item.percentCompanies,
      }))
      state.yearsOfOperationIds = data.map((item) => item.id)
      state.yearsOfOperation = keyBy(data, 'id')
      state.loading.yearsOfOperation = false
    })
    builder.addCase(getYearOfOperation.rejected, (state, action) => {
      state.loading.yearsOfOperation = action.payload.loading
    })
  },
})

export const selectTopIndustryIds = (state) => state[slice.name].topIndustryIds
export const selectTopIndustryById = (id, attr) => (state) => {
  const dataById = state[slice.name].topIndustries
  if (isInValidValue(id)) return dataById
  if (!attr) return dataById[id]
  return dataById[id][attr]
}

export const selectTopProvinceIds = (state) => state[slice.name].topProvinceIds
export const selectTopProvinceById = (id, attr) => (state) => {
  const dataById = state[slice.name].topProvinces
  if (isInValidValue(id)) return dataById
  if (!attr) return dataById[id]
  return dataById[id][attr]
}

export const selectBusinessSizeIds = (state) =>
  state[slice.name].businessSizeIds
export const selectBusinessSizeById = (id, attr) => (state) => {
  const dataById = state[slice.name].businessSize
  if (isInValidValue(id)) return dataById
  if (!attr) return dataById[id]
  return dataById[id][attr]
}

export const selectYearOfOperationIds = (state) =>
  state[slice.name].yearsOfOperationIds
export const selectYearOfOperationById = (id, attr) => (state) => {
  const dataById = state[slice.name].yearsOfOperation
  if (isInValidValue(id)) return dataById
  if (!attr) return dataById[id]
  return dataById[id][attr]
}

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return loadingObj[type]
}

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
